import 'css-chunksrc/client/scenes/projectPopup/tagList/styles.scss';export default {
  "tagList": "_tagList_oiiut_1",
  "list": "_list_oiiut_9",
  "buttonWrapper": "_buttonWrapper_oiiut_18"
};